<template>
  <div class="pc-course-series">
    <div class="pc-course-series-header">
      <h2>竞赛数量设置</h2>
      <div class="pc-button-group">
        <el-button
          @click="manageSeries"
          v-show="isEditting == false"
          class="pc-btn"
        >
          管理
        </el-button>
        <el-button @click="save" v-show="isEditting" class="pc-btn">
          完成
        </el-button>
      </div>
    </div>
    <div class="countBox">
      <div class="count">
        <h2>竞赛最大提交数量 :</h2>
        <p>{{ num }}</p>
      </div>
      <div class="number">
        <el-input-number
          v-show="isEditting == true"
          v-model="num"
          :step-strictly="true"
          @change="handleChange"
          :min="0"
          :max="100"
          label=""
        ></el-input-number>
      </div>
    </div>
  </div>
</template>

<script>
import {
  competitionMaxCommit_Api,
  createCompetitionMaxCommit_Api,
} from "@/apis/competition.api";
export default {
  data() {
    return {
      isEditting: false,
      competitionCount: null,
      competitionCountDetail: {
        competition_id: null,
        max_commit: null,
      },
      num: null,
    };
  },
  mounted() {
    this.getCount();
  },
  methods: {
    getCount() {
      competitionMaxCommit_Api(this.$route.query.id).then((res) => {
        this.competitionCount = res.data;
        this.num = this.competitionCount;
        console.log(res);
      });
    },
    manageSeries() {
      this.isEditting = true;
    },
    save() {
      this.isEditting = false;
      createCompetitionMaxCommit_Api(this.competitionCountDetail).then(
        (res) => {
          console.log(res);
          this.$global.success(this, "设置成功");
        }
      );
    },
    handleChange() {
      if (this.num <= 100) {
        this.competitionCountDetail.competition_id = +this.$route.query.id;
        this.competitionCountDetail.max_commit = this.num;
      } else {
        return;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-course-series {
  @include box-model;
  .countBox {
    display: flex;
    .count {
      display: flex;
      justify-content: start;
      align-items: center;
      border-radius: 4px;
      width: 350px;
      height: 67px;
      margin-top: 10px;
      p {
        font-size: 30px;
      }
    }
    .number {
      margin: 23px 0 0 20px;
    }
  }

  .checkBox {
    display: inline-block;
    width: 50%;
    height: 20px;
    margin-top: 30px;
    div {
      display: flex;
      margin-right: 20px;
      width: 100%;
      .checkBox1 {
        width: 80%;
      }
    }
    div:nth-of-type(2n) {
      margin-right: 0px;
    }
  }
  .pc-course-series-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c0c0c0;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    .pc-button-group {
      margin-top: -10px;
      .pc-btn {
        @include manage-button;
      }
    }
  }

  /deep/ .el-dialog__footer {
    .dialog-footer-button-one {
      @include manage-button;
      background: $test;
      color: $blueBtna;
    }
    .dialog-footer-button-second {
      @include manage-button;
    }
  }
}
</style>
      


// WEBPACK FOOTER //
// src/components/admin/competition/components/CompetitionCount.vue